import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { impersonateClient } from "commons/src/helpers/adviserViewHelpers";

import { routes } from "../../helpers/RouteHelpers";
import { AdviserViewClientSelect } from "./AdviserViewClientSelect";
import { initialiseUserLocationId } from "../../components/DataOperations";

function AdviserViewContainerComponent({ adviserId, clientId, userLocationId }) {
    if (!userLocationId) {
        initialiseUserLocationId();
    }

    if (clientId) {
        return <Redirect to={routes.client.root()} />;
    }

    if (adviserId) {
        return <AdviserViewClientSelect impersonateClient={impersonateClient} />;
    }

    return <Redirect to={routes.public.root()} />;
}

const mapStateToProps = state => ({
    adviserId: state.user.adviserId,
    clientId: state.user.id,
    userLocationId: state.user.userLocationId
});

AdviserViewContainerComponent.propTypes = {
    adviserId: PropTypes.string,
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userLocationId: PropTypes.number
};

export const AdviserViewContainer = connect(mapStateToProps)(AdviserViewContainerComponent);
